import React from "react";

import './FloatingDiv.css'


const FloatinDiv = ({img, icon, text1, text2}) => {
  return (
    // darkMode
    <div className="floatingDiv">
      {icon ? (
        <div className="f-icon">{icon}</div>
      ) : (
        <img src={img} alt="" />
      )}
      <span>
        {text1}
        <br/>
        {text2}
      </span>
    </div>
  );
};

export default FloatinDiv;
